import React from 'react';
import moment from 'moment';

export default ({ value }: { value: Date }) => {
  const m = moment(value).locale('date-card-locale');
  return <>
    {m.format('D MMM YYYY')}&nbsp;<span style={{ color: '#6B778C' }}>{m.format('HH:mm')}</span>
  </>
};